import React from 'react'
import "./footer.scss"

export default function Footer() {
  return (
    <footer>
      Repertorify &copy; 2024. All rights reserved.
    </footer>
  )
}
